import React from 'react'
import ReactDOM from 'react-dom'
//import { createBrowserHistory } from 'history'
import history from './history'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
// import indexRoutes from 'routes/index.jsx'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import configureStore from './store'
// import { connect } from 'react-redux'
// for testing , remove later
// import Dashboard from 'layouts/Dashboard'
// import UserProfile from 'views/Users/UserProfile'
// import CompanyProfile from './views/Users/CompanyPage'
// import GroupProfile from './views/Users/UserGroupPage'
// import DepartmentProfile from './views/Users/DepartmentPage'
// import RequestSubContractorPayment from './views/Applications/RequestSubContractorPayment'
// import TimeOff from './views/Applications/TimeOff'
// import Test from './views/utility/test'
// import DropdownRoutes from './views/Components/DropdownRoutes'

import LoginPage from 'views/Login/LoginPage'
import 'assets/scss/material-dashboard-pro-react.css?v=1.4.0'
import 'assets/my.css'
import indexRoutes from './routes'

import { ApolloProvider } from 'react-apollo'
import { apolloClient } from './services/graphql.js'
import AppContext from './services/context'

// graphql video #23 - setup client
// #24 can be skipped
// #25 setup apollo - https://www.apollographql.com/docs/react/essentials/get-started.html

// let PrivateRoute = ({ component: Component, ...rest }) => {
//   const { auth, isAuthenticated } = rest
//   console.log('in private route', isAuthenticated)
//console.log(this.props)
//   return (
//     <Route
//       {...rest}
//       render={props =>
//         // auth.authenticated ? (
//         isAuthenticated ? (
//           <Component {...props} />
//         ) : (
//           <Redirect
//             to={{
//               pathname: '/login',
//               state: { from: props.location }
//             }}
//           />
//         )
//       }
//     />
//   )
// }
// const mapStateToProps = state => ({
//   ...state
// })
//PrivateRoute = connect(mapStateToProps)(PrivateRoute)

// class Child extends React.Component {
//   //static contextType = AppContext
//   render() {
//     const renderedContext = this.context
//     console.log({ this: this })
//     console.log(renderedContext)
//     console.log({ asd: Child.contextType })
//     return <div>something</div>
//   }
// }
// Child.contextType = AppContext
// const L1 = () => <L2 />
// const L2 = () => <L3 />
// const L3 = () => <Child />

class AuthWrapper extends React.Component {
  state = { isAuthenticated: false }
  render() {
    // <div> isn't needed here, it's used to cheat the limit of not having two children of one router
    // the 2nd/3rd routes there has to match one of those in dashboard, otherwise the catch-all route in
    // dashboard.routes will send it back here and thus get the routing into the indefinite loop
    // very import to load all routes form indexRoutes since in which there is a catch-all of '/'
    // it will render Dashboard first, otherwise the child route will get nowhere to render

    // {this.state.isAuthenticated ? '' : ''}, this is to force this component to be rerendered when the state changes
    // the rerendering only happen when the state changes has impact on UI

    // Till here, the location in history isn't built yet
    // this.props.history && console.log(`pathname is history of AuthWrapper is ${this.props.history.location.pathname}`)

    // Route analysis
    // <Redirect from="*" to="/login" /> will get called since there is only "/login" available when not authed
    // when authed /dashboard and others will be added

    // Routes for easier GUI design -
    //<Route path="/user/profile" component={UserProfile} />

    // console.log('AuthWrapper props:')
    // console.log(this.props)

    return (
      <AppContext.Provider value={this.state}>
        <div>
          <Switch>
            <Route path='/login' component={props =><LoginPage {...props}/>} />
            {this.state.isAuthenticated ? (
              indexRoutes.map((prop, key) => {
                return <Route path={prop.path} component={prop.component} key={key} params={prop.params} isAuthenticated={this.state.isAuthenticated} />
              })
            ) : (
              <Redirect from='*' to={{ pathname: '/login', from: history.location }} />
            )}
          </Switch>
        </div>
      </AppContext.Provider>
    )
  }
}

//, state: this.props.history.location
ReactDOM.render(
  <ApolloProvider client={apolloClient}>
    <Provider store={configureStore()}>
      <Router history={history}>
        <AuthWrapper history={history} />
      </Router>
    </Provider>
  </ApolloProvider>,
  document.getElementById('root')
)

// <Provider store={configureStore()}>
// </Provider>
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
